import React, { useState } from 'react';
import Layout from '../../components/Layout/Layout';
import PrimaryCategories from '../../components/PrimaryCategories/PrimaryCategories';
import styles from './PrimaryCategoriesPage.module.css';

const PrimaryCategoriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Discover');

  const handleCategoryChange = (category) => {
    console.log(`Category changed: ${category}`);
    setSelectedCategory(category);
  };

  const handleCategoryClick = (category) => {
    console.log(`Category clicked: ${category}`);
    setSelectedCategory(category);
  };

  return (
    <Layout width="1440px">
      <div className={styles.primaryCategoriesStack}>
        <PrimaryCategories
          size="Desktop 1440"
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
          onCategoryClick={handleCategoryClick}
        />
      </div>
    </Layout>
  );
};

export default PrimaryCategoriesPage;